import React from 'react';

import { COMMUNITY_PICKER } from '@lumapps/community-pickers/keys';
import { mdiGoogleCirclesExtended } from '@lumapps/lumx/icons';
import { NavigationItemType } from '@lumapps/navigation/types';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { NAVIGATION_ADMIN } from '../../keys';
import { NavigationItemWizardOptionProps } from '../../types';
import { ContentWizardOption } from './ContentWizardOption';

/**
 * Wizard option that will allow the user to create a Community Navigation Item
 * @param props - NavigationItemWizardOptionProps
 */
export const CommunityWizardOption: React.FC<NavigationItemWizardOptionProps> = ({
    fetchAtInstanceLevel,
    ...props
}) => {
    const { translateKey } = useTranslate();

    const description = translateKey(
        fetchAtInstanceLevel
            ? COMMUNITY_PICKER.PICK_COMMUNITIES_FROM_YOUR_SITE
            : NAVIGATION_ADMIN.PICK_COMMUNITY_DESCRIPTION,
    );

    return (
        <ContentWizardOption
            {...props}
            name={translateKey(GLOBAL.COMMUNITY)}
            description={description}
            pageType={NavigationItemType.COMMUNITY}
            pickerType={NavigationItemType.COMMUNITY}
            id="community"
            icon={mdiGoogleCirclesExtended}
        />
    );
};
